(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["parcelamento"] && !Shopify.designMode) return;
  try {
    // Atualiza o parcelamento quando a variante muda
  if (typeof document !== 'undefined') {
    document.addEventListener('variant:change', function(event) {
      const installmentBlocks = document.querySelectorAll('[data-installment-block]');
      
      installmentBlocks.forEach(block => {
        const productId = block.dataset.productId;
        const blockId = block.dataset.blockId;
        const configScript = document.querySelector(`script[data-installment-config="${blockId}"]`);
        
        if (!configScript || !event.detail || !event.detail.product || productId != event.detail.product.id) return;
        
        const config = JSON.parse(configScript.textContent);
        const price = event.detail.variant ? event.detail.variant.price : 0;
        const content = block.querySelector('.installment-content');
        
        if (!content) return;
        
        let installmentCount = 0;
        let installmentValue = 0;
        let showInstallment = false;
        
        if (price >= config.min6x) {
          installmentCount = 6;
          installmentValue = price / 6;
          showInstallment = true;
        } else if (price >= config.min3x) {
          installmentCount = 3;
          installmentValue = price / 3;
          showInstallment = true;
        }
        
        if (showInstallment) {
          const formattedValue = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(installmentValue / 100);
          
          let html = '';
          
          if (config.showIcon) {
            html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display: inline-block; margin-right: 4px; vertical-align: middle;"><path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          }
          
          if (config.textFormat === 'custom' && config.customText) {
            let text = config.customText
              .replace(/\[count\]/g, installmentCount)
              .replace(/\[value\]/g, formattedValue);
            html += text;
          } else {
            switch(config.textFormat) {
              case 'format_2':
                html += `${installmentCount}x de ${formattedValue} sem juros`;
                break;
              case 'format_3':
                html += `Parcele em até ${installmentCount}x sem juros`;
                break;
              case 'format_1':
              default:
                html += `Em até <strong>${installmentCount}x</strong> sem juros de ${formattedValue}`;
            }
          }
          
          content.innerHTML = html;
          block.style.display = 'block';
        } else {
          content.innerHTML = '';
          block.style.display = 'none';
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
